import React from "react"

// import Auth from "auth";
import { API } from "API"
import { ErrorsCallback, SuccessConfirm, SuccessCallback, WarningCallback, QuestionCallback } from "alertService"
import * as Alert from "alertService"
import { thaiBath } from "helpers/ConvertFormat"
import { ISOToDateYMDAndFullTime, ISOToDateAndFullTime } from "helpers/ConvertDate"
import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import Lg from "language"

import { compose } from "recompose"
import { connect } from "react-redux"
import { creditUpdate, listsThemeSMSUpdate } from "store/actions"

// @material-ui/core components =====
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons ===== 
import Filter1Icon from "@material-ui/icons/Filter1";
import SendIcon from "@material-ui/icons/Send";
// import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';
import TimerIcon from '@material-ui/icons/Timer';
import TimerOffIcon from '@material-ui/icons/TimerOff';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';

import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import CustomInput from "components/CustomInput/CustomInput.jsx"
import FormLabel from "@material-ui/core/FormLabel"
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";

// core components =====
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Button from "components/CustomButtons/Button.jsx";
import Datetime from "react-datetime";

// ComponentsPage ===== 

import { cardTitle } from "assets/jss/material-dashboard-pro-react"


import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  mt4: {
    marginTop: "30px"
  },
  titleIcon: {
    marginBottom: -7
  },
  w100: {
    width: "80vw",
    // height:"700px",
  },
  h100: {
    // width: "1000px",
    height: "70vh",
  },
  paper: {
    padding: "15px",
    marginRight: "15px",
  },
}

const ban = ["|", "^", "{", "}", "[", "~", "]", "\\"];
class SendMailPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      status_show_send_date_time: true,
      tel: "",
      message_txt: "",
      sendDatetime: null,
      statusDialogOpen: false,
      listsThemeSMSRaw: []
    }
  }
  componentDidMount() {
    this.props.listsThemeSMSUpdate()
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.listsThemeSMS && nextProps.listsThemeSMS !== nextState.listsThemeSMSRaw) {
      this.setState({
        listsThemeSMSRaw: nextProps.listsThemeSMS,
      }, () => {
        Alert.LoadingClose()
      })
    }
  }
  handleSendMail = () => {
    if (this.state.tel.length < 10) {
      WarningCallback(Lg.ts("ใส่เบอร์ไม่ครบ 10 ตัว"));
    } else if (this.mb_strlen(this.state.message_txt) > (this.checkLanguage(this.state.message_txt) == "TH" ? 536 : 1216)) {
      WarningCallback(Lg.ts("ใส่ข้อความเกินกำหนด"));
    } else if (this.state.message_txt == "") {
      WarningCallback(Lg.ts("ใส่ข้อความก่อน"));
    } else if (this.checkTelFormat(this.state.tel)) {
      WarningCallback(Lg.ts("เบอร์ไม่ถูกต้อง โปรดตรวจสอบอีกครั้ง"));
    } else {
      QuestionCallback(Lg.ts("คุณต้องการส่ง SMS ทันทีใช่หรือไม่?"), "green", () => {
        var tel_list = this.state.tel != "" ? this.state.tel.split(",") : []
        var dataToSend = {
          mobile_number: tel_list,
          message: this.state.message_txt,
          send_datetime: this.state.sendDatetime ? new Date(this.state.sendDatetime).toISOString() : null,
          message_lenguage: this.checkLanguage(this.state.message_txt),
          message_length: this.mb_strlen(this.state.message_txt),
          credit_per_msg: this.celCreditSMS(this.state.message_txt),
        }
        APIPost(UrlServer.URL_POST_SEND_SMS_SAVE_OR_SEND, dataToSend, (datas) => {
          SuccessCallback(datas.message, null, () => {
            this.setState({
              tel: "",
              message_txt: "",
              sendDatetime: null,
              status_show_send_date_time: false
            }, () => {
              this.setState({
                status_show_send_date_time: true
              }, () => {
                this.props.creditUpdate()
              })
            })
          })
        })
      })
    }
  }
  handleChangeState = (key, val) => {
    if (key == "sendDatetime" && val == null) {
      this.setState({
        [key]: val,
        status_show_send_date_time: false
      }, () => {
        this.setState({
          status_show_send_date_time: true
        })
      })

    } else {
      this.setState({
        [key]: val
      })
    }
  }
  checkLanguage = (message) => {
    if (/[ก-๙€]+/gi.test(message) || /([\ud83d-\uffff])/g.test(message)) {
      return "TH";
    } else {
      return "EN";
    }
  }
  celCreditSMS = (message) => {
    if (message === "") {
      return 0;
    }
    //ไทย ห้ามเกิน 536 , อังกฤษ ห้ามเกิน 1216 
    var credit = 0
    var leng = "E";

    var totalcharacter = this.mb_strlen(message)

    if (/[ก-๙€]+/gi.test(message) || /([\ud83d-\uffff])/g.test(message)) {
      //== 70 , 67 ==
      leng = "T";
      if (totalcharacter <= 70) {
        credit = 1;
      } else {
        credit = 1;
        totalcharacter -= 70
        credit += Math.ceil(totalcharacter / 67)
      }
    } else {
      //== 160 , 152 ==
      leng = "E";
      if (totalcharacter <= 160) {
        credit = 1;
      } else {
        credit = 1;
        totalcharacter -= 160
        credit += Math.ceil(totalcharacter / 152)
      }
    }
    return credit
  }
  mb_strlen = (str) => {
    var size = 0;
    for (var i = 0; i < str.length; i++) {
      var res = str.substr(i, 1);
      if (this.inArray(res, ban)) {
        size = size + 2;
      } else {
        size++;
      }
    }
    return size;
  }

  inArray = (needle, haystack) => {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  }
  checkTelFormat = (tel) => {
    if (tel == "") return true
    var res = false
    var value = tel != "" ? tel.split(",") : []
    value.map((row) => {
      if (
        row.length != 10
      ) {
        res = true
      } else if (
        row != parseInt(row)
      ) {
        res = true
      }
    })
    return res
  }
  handleDialogClose = () => {
    this.setState({ statusDialogOpen: false })
  }
  handleListItemClickSMS = (data_sms) => {
    this.setState({
      message_txt: data_sms.txt_sms_message,
      statusDialogOpen: false
    })
  }
  render() {
    const { classes } = this.props
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card >
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <SendIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}> {Lg.ts("ทำการส่ง SMS")}</h4>
            </CardHeader>
            <CardBody>
              <div>
                <h5>{Lg.ts("เงื่อนไขการคิดเครดิตต่อข้อความ")}</h5>
                <GridContainer>
                  <GridItem xs={12} md={6}>
                    <b>{Lg.ts("เมื่อข้อความเป็นภาษาไทยหรือมีภาษาไทยอยู่ในข้อความด้วย")}</b>
                    <ol>
                      <li>{Lg.ts("70 ตัวอักษรแรกคิดเป็น 1 เครดิต")}</li>
                      <li>{Lg.ts("ส่วนที่ 2 จะคิดทุก 67 ตัวอักษรคิดเป็น 1 เครดิต เป็นเศษนับ 1 เครดิต")}</li>
                      <li>{Lg.ts('ถ้ามีสัญลักษณ์พิเศษ  "|", "^", "{" , "}", "[", "~", "]" , "/" จะนับเป็น 2 อักษร')}</li>
                    </ol>
                  </GridItem>
                  <GridItem xs={12} sm={6}>
                    <b>{Lg.ts("เมื่อข้อความเป็นภาษาอังกฤษ")}</b>
                    <ol>
                      <li>{Lg.ts("160 ตัวอักษรแรกคิดเป็น 1 เครดิต")}</li>
                      <li>{Lg.ts("ส่วนที่ 2 จะคิดทุก 152 ตัวอักษรคิดเป็น 1 เครดิต เป็นเศษนับ 1 เครดิต")}</li>
                      <li>{Lg.ts('ถ้ามีสัญลักษณ์พิเศษ  "|", "^", "{" , "}", "[", "~", "]" , "/" จะนับเป็น 2 อักษร')}</li>
                    </ol>
                  </GridItem>
                </GridContainer>
              </div>
              <GridContainer>
                <GridItem xs={6} md={2}>
                  <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                    {Lg.ts("เบอร์ที่ส่ง SMS")}
                  </FormLabel>
                </GridItem>
                <GridItem xs={6} md={4}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      error: this.checkTelFormat(this.state.tel),
                      type: "text",
                      value: this.state.tel,
                      placeholder: "0123456788,0123456789",
                      multiline: true,
                      rows: "2",
                      rowsMax: "8",
                      onChange: e => this.handleChangeState("tel", e.target.value.replace(" ", "").replace("\n", ""))
                    }}
                    helpText={(this.checkTelFormat(this.state.tel) ? (<span className="txt-c-r">* {Lg.ts("ตัวเลข 10 ตัว") + ' ( สามารถใส่ "," เพื่อส่งมากกว่า 1 หมายเลข)'} </span>) : "")}
                  />
                </GridItem>
                <GridItem xs={6} md={2}>
                  <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                    {Lg.ts("ตั้งเวลาส่ง SMS")}
                  </FormLabel>
                </GridItem>
                <GridItem xs={5} md={3} className="m-t-4">
                  {
                    this.state.status_show_send_date_time ?
                      <Datetime
                        timeFormat='HH:mm'
                        onChange={e => this.handleChangeState("sendDatetime", e)}
                        inputProps={{
                          readOnly: true,
                          placeholder: Lg.ts("กดเลือกวันที่ตรงนี้"),
                        }}
                      />
                      : null
                  }
                  <small className="txt-c-b1">{Lg.ts("ถ้าไม่ใส่วันที่เมื่อกดปุ่มส่งจะส่ง SMS ไปยังเบอร์นั้น ๆ ทันที")}</small><br />
                  <small className="txt-c-b1">{Lg.ts("(รูปแบบวันที่ เดือน/วัน/ปี ชั่วโมง:นาที)")}</small>
                </GridItem>
                <GridItem xs={1} md={1} className="m-t-4">
                  {
                    this.state.sendDatetime ?
                      <Button
                        className={this.props.classes.buttonTable}
                        size="sm"
                        round
                        onClick={() => this.handleChangeState("sendDatetime", null)}
                        color="danger"
                      >
                        <TimerOffIcon />
                      </Button>
                      : null
                  }

                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={2} lg={2}>
                  <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                    {Lg.ts("ข้อความ")}
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={12} md={8}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      error: this.state.message_txt.length == "" || (this.mb_strlen(this.state.message_txt) > (this.checkLanguage(this.state.message_txt) == "TH" ? 536 : 1216)),
                      value: this.state.message_txt,
                      placeholder: Lg.ts("ข้อความ"),
                      multiline: true,
                      rows: "4",
                      rowsMax: "8",
                      onChange: e => this.handleChangeState("message_txt", e.target.value)
                    }}
                    helpText={(<span className="txt-c-b">
                      {
                        Lg.ts("ข้อความเป็นภาษา") + " " + this.checkLanguage(this.state.message_txt) + " , " +
                        " " + this.mb_strlen(this.state.message_txt) + " / " + (this.checkLanguage(this.state.message_txt) == "TH" ? "536" : "1,216") + " " + Lg.ts("อักษร") + " , " +
                        Lg.ts("ใช้") + " " + this.celCreditSMS(this.state.message_txt) + " " + Lg.ts("เครดิต")
                      }
                    </span>)}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2} >
                  <Button
                    fullWidth
                    className={this.props.classes.buttonTable}
                    size="sm"
                    round
                    onClick={() => this.setState({ statusDialogOpen: true })}
                    color="info"
                  >
                    <VerticalAlignBottomIcon /> Theme SMS
                  </Button>
                  <small className="txt-c-dorg">สามารถเลือก Theme SMS ที่เป็น Campaign ต่างๆ ได้ (กดปุ่ม)</small>
                </GridItem>

                <GridItem xs={12}>
                  <Button
                    className={this.props.classes.buttonTable}
                    size="sm"
                    round
                    onClick={() => this.handleSendMail()}
                    color="success"
                  >

                    {
                      (this.state.sendDatetime) ?
                        <div>
                          <TimerIcon />{Lg.ts("บันทึกแบบตั้งเวลาส่ง SMS")}
                        </div>
                        :
                        <div>
                          <SendIcon />{Lg.ts("ส่ง SMS ทันที")}
                        </div>
                    }

                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          open={this.state.statusDialogOpen}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            {Lg.ts("เลือก Theme SMS")}
          </DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              {
                (this.state.listsThemeSMSRaw.length > 0) ?
                  <List>
                    {this.state.listsThemeSMSRaw.map((row) => (
                      <ListItem
                        button
                        onClick={(e) => this.handleListItemClickSMS(row)}
                        key={row.theme_name}
                      >
                        <ListItemText primary={row.theme_name} />
                      </ListItem>
                    ))}
                  </List>
                  : null
              }

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={e => { this.handleDialogClose() }} color="primary">
              {Lg.ts("Cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>
    )
  }
}


function mapStateToProps({ credit, listsThemeSMS }) {
  return {
    credit: credit,
    listsThemeSMS: listsThemeSMS,
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { creditUpdate, listsThemeSMSUpdate }
  )
)(SendMailPage)
